import { PciResourceTemplate } from '../features/structureEditor/actions';

export interface FetchPciStimulusTemplatesAction<T extends string> {
    type: T;
    featureId: string;
    itemBankId?: number;
}

export interface FetchPciStimulusTemplatesSuccessAction<T extends string> {
    type: T;
    featureId: string;
    templates: PciResourceTemplate[];
}

export interface FetchPciStimulusTemplatesErrorAction<T extends string> {
    type: T;
    featureId: string;
    error: any;
}

export const createPciStimulusTemplatesActionCreators = <
    TFetch extends string, TSuccess extends string, TError extends string
>(types: { fetch: TFetch; success: TSuccess; error: TError }) => ({
        fetchPciStimulusTemplates: (featureId: string, itemBankId?: number): FetchPciStimulusTemplatesAction<TFetch> => ({
            featureId,
            itemBankId,
            type: types.fetch,
        }),
        fetchPciStimulusTemplatesSuccess: (
            featureId: string,
            templates: PciResourceTemplate[]
        ): FetchPciStimulusTemplatesSuccessAction<TSuccess> => ({
            featureId,
            templates,
            type: types.success,
        }),
        fetchPciStimulusTemplatesError: (featureId: string, error: any): FetchPciStimulusTemplatesErrorAction<TError> => ({
            featureId,
            error,
            type: types.error,
        }),
    });
